import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteCollection } from "../../api/apiCollections";
import parseError from "../../utils/parseError";

/**
 * Hook to delete a collection
 */
export function useDeleteCollection() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteColl,
        isPending: isDeleting,
    } = useMutation({
        mutationFn: deleteCollection,
        onSuccess: (response) => {
            toast.success(response.message || "Collection deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["collections"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete collection");
        },
    });

    return {
        deleteColl,
        isDeleting,
    };
}
